























































import Vue from 'vue'
import UiIcon from '../../UiIcon'
import UiPagination from '../../UiPagination'
import { Data } from '../../UiPagination/UiPagination.types'

export default Vue.extend({
  name: 'UiListingPagination',
  components: {
    UiIcon
  },
  extends: UiPagination,
  props: {
    url: {
      type: String,
      default: '/'
    },
    pageCount: {
      type: Number,
      default: 1
    },
    current: {
      type: Number,
      default: 1
    },
    link: {
      type: Boolean,
      default: true
    },
    showPages: {
      type: Number,
      default: 5
    },
    showPagesCount: {
      type: Number,
      default: 3
    },
    break: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    pageHandler (page: number): void {
      if (typeof this.$router === 'undefined') return
      if (typeof page !== 'undefined') {
        if (page === 1) {
          this.$router.push({ query: { ...this.$route.query, page: undefined } })
        } else {
          this.$router.push({
            query: { ...this.$route.query, page: page.toString() }
          })
        }
      }
    },
    changePageHandler (direction: 'prev' | 'next'): void {
      if (typeof this.$router === 'undefined') return

      let nextPage
      if (direction === 'prev' && this.current > 1) {
        nextPage = this.current - 1
      } else if (direction === 'next' && this.current < this.pageCount) {
        nextPage = this.current + 1
      }

      if (typeof nextPage !== 'undefined') {
        if (nextPage === 1) {
          this.$router.push({ query: { ...this.$route.query, page: undefined } })
        } else {
          this.$router.push({
            query: { ...this.$route.query, page: nextPage.toString() }
          })
        }
      }
    },
    getUrl (number: number): string {
      if (typeof this.$route === 'undefined') return ''

      if (this.current <= this.pageCount) {
        if (this.$route.fullPath.includes('page=')) {
          return this.$route.fullPath.replace(
            `page=${this.current}`,
            `page=${number}`
          )
        } else {
          if (this.$route.fullPath.includes('?')) {
            return this.$route.fullPath + `&page=${number}`
          } else {
            return this.$route.fullPath + `?page=${number}`
          }
        }
      }

      return this.$route.fullPath
    },
    getData (index: number): Data {
      return {
        current: index === this.current,
        url: (this as any).getUrl(index),
        index: index
      }
    }
  }
})
